import { z } from "zod";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
    organizationInvitationId: z.string(),
  }),
  response: z.void(),
};
